import { useQuery } from '@apollo/client';
import { useContext } from 'react';
import type { QueryAttachmentsArgs } from 'sr-types/lib/attachment/v1/graphql';
import type { EntityName } from '../../auth/Security';
import { UserContext } from '../../auth/UserContext';
import { FETCH_POLICY_CONFIG } from '../../constants/constants';
import { client } from '../attachmentsApi';
import { attachmentsQuery } from './attachmentGraphqlApi';

export const useGetAttachments = (entityName: EntityName, entityId: string, skip: boolean, contextTerm?: string) => {
    const { activeOrganizationAccount } = useContext(UserContext);

    const variables: QueryAttachmentsArgs = {
        entityType: entityName,
        entityId,
        ...(contextTerm ? { contextTerm } : {})
    };

    const { data, loading, refetch, error } = useQuery(attachmentsQuery, {
        variables,
        context: { headers: { ownerId: activeOrganizationAccount } },
        client,
        fetchPolicy: FETCH_POLICY_CONFIG.apolloFetchPolicy,
        notifyOnNetworkStatusChange: true,
        skip
    });

    return { data, loading, refetch, error };
};
